import type { ICollectionPipelineStatusV3, IStepProgress } from '@repo/sdk';

function stepComplete(step: IStepProgress | undefined): boolean {
  return step !== undefined && step.total > 0 && step.done >= step.total;
}

// A row is "complete" when every progress column is fully green: subtitle imported, no
// missing clips, and populate/translate/crop/triage/upload/publish all at 100%. The
// informational columns (Match/Matched/AI/Manual counts, Rejected) are ignored on purpose.
export function isCollectionComplete(
  item: ICollectionPipelineStatusV3,
  hasVideo: boolean | undefined,
): boolean {
  const { steps } = item;
  return (
    steps.srtImported &&
    hasVideo !== false &&
    steps.clipsMissing.count === 0 &&
    stepComplete(steps.populated) &&
    stepComplete(steps.translated) &&
    stepComplete(steps.clipsCropped) &&
    stepComplete(steps.triaged) &&
    stepComplete(steps.clipsUploaded) &&
    stepComplete(steps.published)
  );
}
